<template>
  <div>
    <h2 class="intro-y text-lg font-medium mt-10">Catalogo de Clientes</h2>
    <div class="grid grid-cols-12 gap-6 mt-5">
      <div
        class="
          intro-y
          col-span-12
          flex flex-wrap
          sm:flex-nowrap
          items-center
          mt-2
        "
      >
        <div class="w-full sm:w-auto mt-3 sm:mt-0 sm:ml-auto md:ml-0">
          <div class="w-72 relative text-gray-700 dark:text-gray-300">
            <input
              v-model="search"
              type="text"
              class="form-control w-72 box pr-10 placeholder-theme-13"
              placeholder="Buscar"
              @change="setFirstPage"
            />
            <SearchIcon
              class="w-4 h-4 absolute my-auto inset-y-0 mr-3 right-0"
            />
          </div>
        </div>
        <div class="hidden md:block mx-auto text-gray-600"></div>
        <button
          class="btn btn-success shadow-md mr-2 w-60"
          @click="showModalCreate"
        >
          Nuevo cliente
        </button>
        <button
          class="btn btn-info shadow-md mr-2 w-60"
          @click="downloadReport"
        >
          Descargar reporte
        </button>
      </div>
      <!-- BEGIN: Data List -->
      <template v-if="clients">
        <div class="intro-y col-span-12 overflow-auto lg:overflow-visible">
          <table class="table table-report -mt-2" aria-describedby="table">
            <thead>
              <tr>
                <th id="idH" class="whitespace-nowrap">ID</th>
                <th id="nombre" class="text-center whitespace-nowrap">
                  Nombre(s)
                </th>
                <th id="Apellidos" class="text-center whitespace-nowrap">
                  Apellidos
                </th>
                <th id="Correo" class="text-center whitespace-nowrap">
                  Correo
                </th>
                <th id="Residentes" class="text-center whitespace-nowrap">
                  Residentes
                </th>
                <th id="actionsH" class="text-center whitespace-nowrap">
                  Acciones
                </th>
              </tr>
            </thead>
            <tbody>
              <tr :key="row.id" v-for="row in elements">
                <td class="w-10 font-medium">
                  {{ row.id }}
                </td>
                <td class="text-center w-10 font-medium">
                  {{ row.name }}
                </td>
                <td class="text-center w-10 font-medium">
                  {{ row.last_name }}
                </td>
                <td class="text-center w-10 font-medium">
                  {{ row.email }}
                </td>
                <td class="text-center w-10 font-medium">
                  <span
                    v-for="item in Array.isArray(row.residents)
                      ? row.residents.map(element => element.full_name)
                      : []"
                    :key="item"
                  >
                    {{ item }} <br />
                  </span>
                </td>
                <td class="table-report__action w-56">
                  <div class="flex justify-center items-center">
                    <a
                      class="flex items-center mr-3 text-green-600"
                      href="javascript:;"
                      @click="setToEdit(row)"
                    >
                      <CheckSquareIcon class="w-4 h-4 mr-1" />
                      Editar
                    </a>
                    <a
                      href="javascript:;"
                      class="flex items-center text-red-700"
                      @click="setToDelete(row)"
                    >
                      <Trash2Icon class="w-4 h-4 mr-1" /> Eliminar
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- END: Data List -->
        <!-- BEGIN: Pagination -->
        <div
          class="
            intro-y
            col-span-12
            flex flex-wrap
            sm:flex-row sm:flex-nowrap
            items-center
            py-10
          "
          v-if="pages > 1"
        >
          <ul class="pagination ml-auto" style="margin-right: revert;">
            <li @click="setFirstPage" v-if="page !== 1">
              <a class="pagination__link" href="javascript:;">
                <ChevronsLeftIcon class="w-4 h-4" />
              </a>
            </li>
            <li @click="changePageNegative" v-if="page !== 1">
              <a class="pagination__link" href="javascript:;">
                <ChevronLeftIcon class="w-4 h-4" />
              </a>
            </li>
            <li
              :key="element"
              v-for="element in [...Array(maxShowButtonPages).keys()].map(
                (dataElement, index) =>
                  activeGroup * maxShowButtonPages -
                  (maxShowButtonPages - index) +
                  1
              )"
            >
              <template v-if="element <= pages">
                <a
                  class="pagination__link"
                  href="javascript:;"
                  @click="page = element"
                  :class="{ 'pagination__link--active': element === page }"
                  >{{ element }}
                </a>
              </template>
            </li>
            <li v-if="page !== pages" @click="changePagePositive">
              <a class="pagination__link" href="javascript:;">
                <ChevronRightIcon class="w-4 h-4" />
              </a>
            </li>
            <li @click="setlastPage" v-if="page !== pages">
              <a class="pagination__link" href="javascript:;">
                <ChevronsRightIcon class="w-4 h-4" />
              </a>
            </li>
          </ul>
        </div>
        <!-- END: Pagination -->
      </template>
    </div>
    <!-- BEGIN: MODALS -->

    <!-- BEGIN: Modal Add Row -->
    <div ref="createRow" class="modal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <form @submit.prevent="createAction">
          <div class="modal-content">
            <!-- BEGIN: Modal Header -->
            <div class="modal-header">
              <h2 class="font-medium text-base mr-auto">Nuevo cliente</h2>
              <a data-dismiss="modal" href="javascript:;">
                <XIcon class="w-5 h-5 text-gray-500" />
              </a>
            </div>
            <!-- END: Modal Header -->
            <!-- BEGIN: Modal Body -->
            <div class="modal-body grid grid-cols-12 gap-4 gap-y-3">
              <div class="col-span-12">
                <label class="form-label">Nombre(s)</label>
                <input
                  v-model="createForm.name"
                  type="text"
                  class="form-control"
                  placeholder="Nombre(s)"
                  required
                />
                <template v-if="v$.createForm.name.$errors">
                  <div
                    v-for="(error, index) in v$.createForm.name.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo es requerido</strong
                    >
                    <strong v-else-if="error.$validator === 'maxLength'"
                      >La longitud máxima es de 100 caracteres</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12 mt-2">
                <label class="form-label">Apellidos</label>
                <input
                  v-model="createForm.last_name"
                  type="text"
                  class="form-control"
                  placeholder="Apellidos"
                  required
                />
                <template v-if="v$.createForm.last_name.$errors">
                  <div
                    v-for="(error, index) in v$.createForm.last_name.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo es requerido</strong
                    >
                    <strong v-else-if="error.$validator === 'maxLength'"
                      >La longitud máxima es de 100 caracteres</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12 mt-2">
                <label class="form-label">Correo</label>
                <input
                  v-model="createForm.email"
                  type="email"
                  class="form-control"
                  placeholder="Correo"
                  required
                />
                <template v-if="v$.createForm.email.$errors">
                  <div
                    v-for="(error, index) in v$.createForm.email.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo es requerido</strong
                    >
                    <strong v-else-if="error.$validator === 'email'"
                      >El campo debe de ser correo</strong
                    >
                    <strong v-else-if="error.$validator === 'maxLength'"
                      >La longitud máxima es de 250 caracteres</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12 mt-2">
                <label class="form-label">Contraseña</label>
                <input
                  v-model="createForm.password"
                  type="password"
                  class="form-control"
                  placeholder="Contraseña"
                  required
                />
                <template v-if="v$.createForm.password.$errors">
                  <div
                    v-for="(error, index) in v$.createForm.password.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo es requerido</strong
                    >
                    <strong v-else-if="error.$validator === 'maxLength'"
                      >La longitud máxima es de 100 caracteres</strong
                    >
                    <strong v-else-if="error.$validator === 'minLength'"
                      >La longitud mínima es de 6 caracteres</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12 mt-2 max-h-72 overflow-y-auto">
                <label class="form-label">Residentes</label>
                <div
                  class="form-check mt-2"
                  v-for="resident in createForm.residents"
                  :key="resident.id"
                >
                  <input
                    :id="'checkbox-switch-' + resident.id"
                    class="form-check-input"
                    type="checkbox"
                    v-model="resident.checked"
                  />
                  <label
                    class="form-check-label"
                    :for="'checkbox-switch-' + resident.id"
                    >{{ resident.full_name }}
                  </label>
                </div>
              </div>
            </div>
            <!-- END: Modal Body -->
            <!-- BEGIN: Modal Footer -->
            <div class="modal-footer text-right">
              <button
                type="button"
                data-dismiss="modal"
                class="btn btn-outline-secondary w-20 mr-1"
              >
                Cancelar
              </button>
              <button
                type="submit"
                :disabled="v$.createForm.$invalid"
                class="btn btn-primary w-20"
                :class="{ 'btn-danger': v$.createForm.$invalid }"
              >
                Crear
              </button>
            </div>
            <!-- END: Modal Footer -->
          </div>
        </form>
      </div>
    </div>
    <!-- END: Modal Add Row -->

    <!-- BEGIN: Delete Confirmation Modal -->
    <div ref="deleteRow" class="modal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div v-if="rowSelected" class="modal-body p-0">
            <div class="p-5 text-center">
              <XCircleIcon class="w-16 h-16 text-red-700 mx-auto mt-3" />
              <div class="text-3xl mt-5">¿Estás seguro?</div>
              <div class="text-gray-600 mt-2">
                ¿Realmente quieres eliminar el registro
                <span style="font-weight: bold"
                  >{{ rowSelected.name }} {{ rowSelected.last_name }}</span
                >?
              </div>
            </div>
            <div class="px-5 pb-8 text-center">
              <button
                type="button"
                data-dismiss="modal"
                class="btn btn-outline-secondary w-24 mr-1"
              >
                Cancelar
              </button>
              <button
                type="button"
                class="btn btn-danger w-24"
                @click="deleteAction"
              >
                Eliminar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END: Delete Confirmation Modal -->

    <!-- BEGIN: Modal Edit Row -->
    <div ref="editRow" class="modal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <form @submit.prevent="editAction">
          <div class="modal-content">
            <!-- BEGIN: Modal Header -->
            <div class="modal-header">
              <h2 class="font-medium text-base mr-auto">Editar cliente</h2>
              <a data-dismiss="modal" href="javascript:;">
                <XIcon class="w-5 h-5 text-gray-500" />
              </a>
            </div>
            <!-- END: Modal Header -->
            <!-- BEGIN: Modal Body -->
            <div class="modal-body grid grid-cols-12 gap-4 gap-y-3">
              <div class="col-span-12">
                <label class="form-label">Nombre(s)</label>
                <input
                  v-model="editForm.name"
                  type="text"
                  class="form-control"
                  placeholder="Nombre(s)"
                  required
                />
                <template v-if="v$.editForm.name.$errors">
                  <div
                    v-for="(error, index) in v$.editForm.name.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo es requerido</strong
                    >
                    <strong v-else-if="error.$validator === 'maxLength'"
                      >La longitud máxima es de 100 caracteres</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12 mt-2">
                <label class="form-label">Apellidos</label>
                <input
                  v-model="editForm.last_name"
                  type="text"
                  class="form-control"
                  placeholder="Apellidos"
                  required
                />
                <template v-if="v$.editForm.last_name.$errors">
                  <div
                    v-for="(error, index) in v$.editForm.last_name.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo es requerido</strong
                    >
                    <strong v-else-if="error.$validator === 'maxLength'"
                      >La longitud máxima es de 100 caracteres</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12 mt-2">
                <label class="form-label">Correo</label>
                <input
                  v-model="editForm.email"
                  type="email"
                  class="form-control"
                  placeholder="Correo"
                  required
                />
                <template v-if="v$.editForm.email.$errors">
                  <div
                    v-for="(error, index) in v$.editForm.email.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo es requerido</strong
                    >
                    <strong v-else-if="error.$validator === 'email'"
                      >El campo debe de ser correo</strong
                    >
                    <strong v-else-if="error.$validator === 'maxLength'"
                      >La longitud máxima es de 250 caracteres</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12 mt-2">
                <label class="form-label">Contraseña</label>
                <input
                  v-model="editForm.password"
                  type="password"
                  class="form-control"
                  placeholder="Contraseña"
                />
                <template v-if="v$.editForm.password.$errors">
                  <div
                    v-for="(error, index) in v$.editForm.password.$errors"
                    :key="index"
                    class="text-red-700 mt-2"
                  >
                    <strong v-if="error.$validator === 'required'"
                      >El campo es requerido</strong
                    >
                    <strong v-else-if="error.$validator === 'maxLength'"
                      >La longitud máxima es de 100 caracteres</strong
                    >
                    <strong v-else-if="error.$validator === 'minLength'"
                      >La longitud mínima es de 6 caracteres</strong
                    >
                  </div>
                </template>
              </div>
              <div class="col-span-12 mt-2 max-h-72 overflow-y-auto">
                <label class="form-label">Residentes</label>
                <div
                  class="form-check mt-2"
                  v-for="resident in editForm.residents"
                  :key="resident.id"
                >
                  <input
                    :id="'checkbox-switch-' + resident.id"
                    class="form-check-input"
                    type="checkbox"
                    v-model="resident.checked"
                  />
                  <label
                    class="form-check-label"
                    :for="'checkbox-switch-' + resident.id"
                    >{{ resident.full_name }}
                  </label>
                </div>
              </div>
            </div>
            <!-- END: Modal Body -->
            <!-- BEGIN: Modal Footer -->
            <div class="modal-footer text-right">
              <button
                type="button"
                data-dismiss="modal"
                class="btn btn-outline-secondary w-20 mr-1"
              >
                Cancelar
              </button>
              <button
                type="submit"
                :disabled="v$.editForm.$invalid"
                class="btn btn-primary w-20"
                :class="{ 'btn-danger': v$.editForm.$invalid }"
              >
                Modificar
              </button>
            </div>
            <!-- END: Modal Footer -->
          </div>
        </form>
      </div>
    </div>
    <!-- END: Modal Edit Row -->

    <!-- END: MODALS -->
  </div>
</template>

<script>
import { cleanSession, getFirstErrorMessage } from '../../../utils/tools'
import useVuelidate from '@vuelidate/core'
import { maxLength, required, email, minLength } from '@vuelidate/validators'
import { saveAs } from 'file-saver'
import moment from 'moment-timezone'

export default {
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      clients: undefined,
      rowSelected: undefined,
      createForm: {
        name: '',
        last_name: '',
        email: '',
        password: '',
        residents: []
      },
      editForm: {
        name: '',
        last_name: '',
        email: '',
        password: '',
        residents: []
      },
      search: '',
      elementsByPage: 3,
      maxShowButtonPages: 3,
      page: 1,
      activeGroup: 1
    }
  },
  validations() {
    return {
      createForm: {
        name: { required, $autoDirty: true, maxLength: maxLength(100) },
        last_name: { required, $autoDirty: true, maxLength: maxLength(100) },
        email: { $autoDirty: true, email, maxLength: maxLength(250) },
        password: {
          required,
          $autoDirty: true,
          maxLength: maxLength(100),
          minLength: minLength(6)
        }
      },
      editForm: {
        name: { required, $autoDirty: true, maxLength: maxLength(100) },
        last_name: { required, $autoDirty: true, maxLength: maxLength(100) },
        email: { $autoDirty: true, email, maxLength: maxLength(250) },
        password: {
          $autoDirty: true,
          maxLength: maxLength(100),
          minLength: minLength(6)
        }
      }
    }
  },
  validationConfig: {
    $lazy: false
  },
  async beforeMount() {
    this.$store.commit('main/setShowSpinner', true)
    await this.getResidents()
    await this.getInitialData()
    this.$store.commit('main/setShowSpinner', false)
  },
  methods: {
    async getResidents() {
      try {
        const response = await this.axios.get('/residents', {
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.token}`
          }
        })
        this.residents = response.data || []
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      }
    },
    async getInitialData() {
      try {
        this.setFirstPage()
        const response = await this.axios.get('/clients', {
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.token}`
          }
        })
        this.clients = response.data || []
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      }
    },
    async downloadReport() {
      this.$store.commit('main/setShowSpinner', true)
      try {
        const response = await this.axios.get('/client-file', {
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.token}`
          },
          responseType: 'blob'
        })
        saveAs(
          response.data,
          `Clientes Información ${moment().format('DD-MM-YYYY')}.xlsx`
        )
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
      }
    },
    showModalCreate() {
      this.createForm = {
        name: '',
        last_name: '',
        email: '',
        password: '',
        residents: [...this.residents]
      }
      this.v$.$reset()
      const modal = this.$refs.createRow
      cash(modal).modal('show')
    },
    async createAction() {
      this.$store.commit('main/setShowSpinner', true)
      const modal = this.$refs.createRow
      cash(modal).modal('hide')
      try {
        const response = await this.axios.post(
          '/create-client',
          {
            name: this.createForm.name,
            last_name: this.createForm.last_name,
            email: this.createForm.email,
            password: this.createForm.password
          },
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.token}`
            }
          }
        )
        const residentsClient = this.createForm.residents
          .filter(resident => resident.checked)
          .map(resident => resident.id)

        if (residentsClient && residentsClient.length) {
          await this.axios.post(
            '/assign-client-residents',
            {
              user_id: response.data.user_id,
              residents: residentsClient
            },
            {
              headers: {
                Authorization: `Bearer ${this.$store.state.auth.token}`
              }
            }
          )
        }

        await this.getInitialData()
        this.$toast.success('El registro se ha creado con exito', {
          position: 'top'
        })
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
        window.scrollTo(0, 0)
      }
    },
    setToDelete(row) {
      this.rowSelected = row
      const modal = this.$refs.deleteRow
      cash(modal).modal('show')
    },
    async deleteAction() {
      const modal = this.$refs.deleteRow
      cash(modal).modal('hide')
      this.$store.commit('main/setShowSpinner', true)
      try {
        await this.axios.delete(`/delete-client/${this.rowSelected.id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.token}`
          }
        })
        await this.getInitialData()
        this.$toast.success(
          'El registro ha sido eliminado satisfactoriamente',
          {
            position: 'top'
          }
        )
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
        window.scrollTo(0, 0)
      }
    },
    setToEdit(row) {
      this.rowSelected = row
      this.editForm = {
        name: this.rowSelected.name,
        last_name: this.rowSelected.last_name,
        email: this.rowSelected.email,
        password: '',
        residents: [...this.residents].map(resident => ({
          ...resident,
          checked: !!this.rowSelected.residents.find(
            residentRowSelected => residentRowSelected.id === resident.id
          )
        }))
      }
      this.v$.$reset()
      const modal = this.$refs.editRow
      cash(modal).modal('show')
      setTimeout(() => {
        cash('.modal.overflow-y-auto.show').css('z-index', '9998')
      }, 1000)
    },
    async editAction() {
      this.$store.commit('main/setShowSpinner', true)
      const modal = this.$refs.editRow
      cash(modal).modal('hide')
      try {
        const body = {
          name: this.editForm.name,
          last_name: this.editForm.last_name,
          email: this.editForm.email
        }
        if (this.editForm.password && this.editForm.password.length) {
          body.password = this.editForm.password
        }
        await this.axios.put(`/update-client/${this.rowSelected.id}`, body, {
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.token}`
          }
        })
        const residentsClient = this.editForm.residents
          .filter(resident => resident.checked)
          .map(resident => resident.id)

        await this.axios.post(
          '/assign-client-residents',
          {
            user_id: this.rowSelected.id,
            residents: residentsClient
          },
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.token}`
            }
          }
        )
        await this.getInitialData()
        this.$toast.success('El registro se ha modificado con exito', {
          position: 'top'
        })
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
        window.scrollTo(0, 0)
      }
    },
    changePagePositive() {
      const page = this.page + 1
      if (page > this.activeGroup * this.maxShowButtonPages) {
        this.activeGroup++
      }
      this.page++
    },
    changePageNegative() {
      const page = this.page - 1
      if (page <= (this.activeGroup - 1) * this.maxShowButtonPages) {
        this.activeGroup = this.activeGroup - 1 === 0 ? 1 : this.activeGroup - 1
      }
      this.page--
    },
    setFirstPage() {
      this.page = 1
      this.activeGroup = 1
    },
    setlastPage() {
      this.page = this.pages
      this.activeGroup = this.totalGroups
    }
  },
  computed: {
    filteredElements() {
      if (this.clients) {
        let elements = this.clients
        if (this.search && this.search.length) {
          elements = elements.filter(
            row =>
              row.name
                .toUpperCase()
                .includes(this.search.trim().toUpperCase()) ||
              row.last_name
                .toUpperCase()
                .includes(this.search.trim().toUpperCase()) ||
              row.email.toUpperCase().includes(this.search.trim().toUpperCase())
          )
        }
        return elements
      }
      return []
    },
    elements: function() {
      if (this.filteredElements) {
        const takeElements =
          this.elementsByPage * this.page - this.filteredElements.length < 0
            ? this.elementsByPage * this.page
            : this.filteredElements.length
        return this.filteredElements.slice(
          this.elementsByPage * this.page - this.elementsByPage,
          takeElements
        )
      }
      return []
    },
    pages: function() {
      return this.filteredElements
        ? Math.ceil(this.filteredElements.length / this.elementsByPage)
        : 1
    },
    totalGroups: function() {
      return Math.ceil(this.pages / this.maxShowButtonPages)
    }
  }
}
</script>
